export default "__VITE_ASSET__DODL$lQ9__"